// extracted by mini-css-extract-plugin
export default {"answer":"Question_answer__JUWrN"};